export const kalmstayFieldsConfig = {    
    name: {
        validations: {
            string: true,
            allow_null: true,
            'minimal-letters': 2,
            'maximal-letters': 50,
            required: true,
        }
    },
    surname: {
        validations: {
            string: true,
            allow_null: true,
            'minimal-letters': 2,
            'maximal-letters': 50,
            required: true,
        }
    },
    gender: {
        validations: {
            string: true,
            allow_null: true,
            required: true,
        }
    },
    birthday: {
        validations: {
            date: true,
            allow_null: true,
            'max-date-now': true,
            typeError: '-',
            required: true,
        }
    },
    nationality: {
        validations: {
            string: true,
            allow_null: true,
            'minimal-letters': 2,
            required: true,
        }
    },
    dni: {
        validations: {
            required: true,
            string: true,
            allow_null: true,
            'only-numbers-and-letters': true,
            'minimal-letters': 6,
            'maximal-letters': 12
        }
    },
    dniType: {
        validations: {
            string: true,
            allow_null: true,
            'maximal-letters': 12,
            'only-numbers-and-letters': true,
            required: true,
        }
    },
    dniIssueDate: {
        validations: {
            date: true,
            allow_null: true,
            'max-date-now': true,
            typeError: '-',
            required: true,
        }
    },
    photos: {
        dniFront: {
            validations: {
                string: true,
                allow_null: true,
                required_for_pax_0_foreign: true
            }
        },
        dniBack: {
            validations: {
                string: true,
                allow_null: true,
                required_for_pax_0_foreign: true,
            }
        },
        selfie: {
            validations: {
                string: true,
                allow_null: true,
            }
        }
    },
    address: {
        validations: {
            string: true,
            allow_null: true,
            required: true
        }
    },
    zipCode: {
        validations: {
            string: true,
            allow_null: true,
            required: true
        }
    },
    age: {
        validations: {
            number: true,
            'minimal-digits': 0,
            'maximal-digits': 120,
            allow_null: true,
            required: true
        }
    },
    residence: {
        validations: {
            string: true,
            allow_null: true,
            'minimal-letters': 2,
            required: true
        }
    },
    city: {
        validations: {
            string: true,
            allow_null: true,
            'minimal-letters': 2,
            required: true
        }
    }
}